import React from 'react';
import strings from 'strings';
import * as styles from './ActiveTransporterBanner.scss';

import { Banner } from '../Banner';

const ActiveTransporterBanner = (props) => {
  const {
    activeTransporterUrl,
    closeBanner,
    imageUrl,
  } = props;

  return (
    <Banner
      url={activeTransporterUrl}
      closeBanner={closeBanner}
      primaryText={strings.searchActiveTransporters}
      secondaryText={strings.useWhenWaitingLong}
      buttonText={strings.try}
      imageUrl={imageUrl}
      imageAlt="truck-image"
      className={styles.activeTransporterBanner}
    />
  );
};

export default ActiveTransporterBanner;
